import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './select';
import { cn } from '../../lib/utils';
import { Languages as LanguagesIcon, Loader2 } from 'lucide-react';

export const Languages = ({
  value,
  onChange,
  icon,
  className = '',
  isLoading,
  disabled,
}: {
  value: string;
  icon?: boolean;
  className?: string;
  onChange: (value: string) => void;
  isLoading: boolean;
  disabled?: boolean;
}) => {
  return (
    <Select disabled={disabled} value={value} onValueChange={onChange}>
      <SelectTrigger className={cn(icon ? 'w-12' : 'w-[100px]', className)}>
        {icon ? (
          isLoading ? (
            <Loader2 className="w-5 h-5 animate-spin text-gray-500" />
          ) : (
            <LanguagesIcon className="w-8 h-8" />
          )
        ) : (
          <span className="!flex items-center gap-2">
            <SelectValue placeholder="Language" />
            {isLoading && <Loader2 className="w-5 h-5 animate-spin text-gray-500" />}
          </span>
        )}
      </SelectTrigger>
      <SelectContent className="max-h-[300px] overflow-y-auto">
        <SelectGroup>
          <SelectItem value="en-US">English</SelectItem>
          <SelectItem value="es-ES">Spanish</SelectItem>
          <SelectItem value="fr-FR">French</SelectItem>
          <SelectItem value="de-DE">German</SelectItem>
          <SelectItem value="zh-CN">Chinese</SelectItem>
          <SelectItem value="ja-JP">Japanese</SelectItem>
          <SelectItem value="ar-SA">Arabic</SelectItem>
          <SelectItem value="ru-RU">Russian</SelectItem>
          <SelectItem value="it-IT">Italian</SelectItem>
          <SelectItem value="pt-PT">Portuguese</SelectItem>
          <SelectItem value="nl-NL">Dutch</SelectItem>
          <SelectItem value="pl-PL">Polish</SelectItem>
          <SelectItem value="tr-TR">Turkish</SelectItem>
          <SelectItem value="vi-VN">Vietnamese</SelectItem>
          <SelectItem value="th-TH">Thai</SelectItem>
          <SelectItem value="id-ID">Indonesian</SelectItem>
          <SelectItem value="ms-MY">Malay</SelectItem>
          <SelectItem value="hi-IN">Hindi</SelectItem>
          <SelectItem value="bn-BD">Bengali</SelectItem>
          <SelectItem value="ta-IN">Tamil</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
